import React from 'react';
import { useTranslation } from "react-i18next";


const AdvantageSection = () => {
    const descriptions = [
        "access_to_solutions",
        "wide_range_of_it_solutions",
        "professional_training_and_support",
        "round_the_clock_support",
        "commitment_to_digital_transformation",
        "assistance_in_adapting_to_challenges"
    ];
    
    const { t } = useTranslation("about"); // Hook to use translations
    return (
        <div className="relative min-h-[984px] sm:h-[100vh] lg:min-h-[684px] min-h-[811px] md:h-[592px] bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('/assets/advantage.png')" }}>
            <div className="absolute inset-0 flex flex-col items-center justify-center text-color-3 text-center px-4 md:px-8 lg:px-16">
                <div>
                    <h1 className="web-heading-section mb-4 md:mb-6 text-white md:text-left sm:mx-12">
                        {t("advantages_of_working_with_taukenai")}
                    </h1>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full max-w-6xl">
                        {[...Array(6)].map((_, index) => (
                            <div
                                key={index}
                                className="rounded-lg shadow-md p-4 md:p-12 bg-white bg-opacity-5 backdrop-blur-md h-auto flex items-center text-center justify-center"
                            >
                                <p className="text-sm md:text-base text-gray-200 px-2 py-2">
                                {t(descriptions[index])}

                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>

    );
};

export default AdvantageSection;
